// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-sheet.v-card[data-v-2a5b17a2]{border-radius:10px}", ""]);
// Exports
module.exports = exports;
